import type {
  CampaignClaimStatusFromCodeApiData,
  CampaignClaimStatusFromCodeApiResponses,
  CampaignGetFromCodeApiData,
  CampaignGetFromCodeApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint } from '../defineResource';

export const getCampaignFromCodeEndpoint = dataEndpoint<CampaignGetFromCodeApiData, CampaignGetFromCodeApiResponses>({
  getUrl: ({ code }) => apiUrl(`campaigns/from-code/${code}/`)
});

export const getCampaignClaimStatusFromCodeEndpoint = dataEndpoint<
  CampaignClaimStatusFromCodeApiData,
  CampaignClaimStatusFromCodeApiResponses
>({
  getUrl: ({ code, userGroupId }) => apiUrl(`campaigns/from-code/${code}/claim-status/`, { userGroupId })
});
